import { motion } from 'motion/react'
import styled, { css } from 'styled-components'

export const ProductImage = styled.img`
  height: 72px;
  width: 72px;
  aspect-ratio: 1/1;
  object-fit: contain;
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

const baseRowStyles = css`
  border-radius: ${props => props.theme.primitives.radius.radius2};

  ${props =>
    props.selected &&
    css`
      background-color: ${props.theme.colors.success.surface};

      &:hover {
        background-color: ${props.theme.colors.success.surface};
      }
    `}

  td {
    padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  }

  td:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  td:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.colors.background.secondary};
  }
`

export const SpacerRow = styled.tr`
  height: ${props => props.theme.spacing.sp8};
`

export const ProductRow = styled(motion.tr)`
  ${baseRowStyles}

  ${props =>
    props.expanded &&
    css`
      td:first-child {
        border-bottom-left-radius: 0;
      }

      td:last-child {
        border-bottom-right-radius: 0;
      }
    `}
`

export const VariantRow = styled(motion.tr)`
  ${baseRowStyles}

  td:first-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: ${props => (props.isLast ? '8px' : '0')};
  }

  td:last-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: ${props => (props.isLast ? '8px' : '0')};
  }
`

export const CheckboxCell = styled.td`
  width: ${props => props.theme.size.L};
`

export const ProductCell = styled.td`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const ProductImageCell = styled.td`
  width: 72px;
`

export const ItemImage = styled.img`
  height: 52px;
  width: 52px;
  aspect-ratio: 1/1;
  object-fit: contain;
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const ItemCountryInfo = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const ItemCell = styled.td`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const ItemInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const VerticalUnion = styled.div`
  position: absolute;
  left: 50px;
  width: 1px;
  background-color: ${props => props.theme.colors.border.default};

  ${props =>
    props.isFirstItem &&
    css`
      top: 0px;
      height: 50%;
    `}

  ${props =>
    !props.isFirstItem &&
    css`
      top: -50%;
      height: 100%;
    `}
`

export const HorizontalUnion = styled.div`
  position: absolute;
  left: 50px;
  top: 50%;
  width: 50px;
  height: 1px;
  background-color: ${props => props.theme.colors.border.default};
`
